module.exports = __webpack_public_path__ + "img/p3_8.9f4770ac.webp";